import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";

const withAuth = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading"); // loading | authed

    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        if (!user) {
          navigate("/login");
        } else {
          setStatus("authed");
        }
      });
      return () => unsubscribe();
    }, [navigate]);

    // Tant que Firebase n'a pas confirmé la session, on n'affiche pas
    // la page protégée (évite le flash de contenu / la redirection visible).
    if (status === "loading") {
      return <div className="bb-loading">Chargement…</div>;
    }

    return <Component {...props} />;
  };
};

export default withAuth;
